(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-angle-tiers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BOX = '.CartContent-BoxSelector--box';
    var BOX_SELECTED = 'CartContent-BoxSelector--selected';
    var CARD = 'article.Category-ProductCard';
    var CARD_ADDED = 'Category-ProductCard__ProductCardAdded';
    var CARD_BUTTON = '.Category-ProductCard__Button';
    var programmatic = false;

    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function builderRoot() {
      var host = document.querySelector('mw-build-offer');
      return host && host.shadowRoot ? host.shadowRoot : null;
    }

    function boxQuantities() {
      var offer = window.mwBuildOffer;
      var boxes = offer && offer.config && offer.config.offer_rules && offer.config.offer_rules.boxes;
      return boxes
        ? boxes.map(function (box) {
            return box.qty;
          })
        : null;
    }

    function boxElements(root) {
      return Array.prototype.slice.call(root.querySelectorAll(BOX));
    }

    function selectedQty(root) {
      var quantities = boxQuantities();
      var boxes = boxElements(root);
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].classList.contains(BOX_SELECTED)) return quantities ? quantities[i] : null;
      }
      return null;
    }

    function selectedProducts(root) {
      return Array.prototype.slice.call(root.querySelectorAll(CARD + '.' + CARD_ADDED)).map(function (card) {
        return card.id.split('-').pop();
      });
    }

    function markTiers(section, qty) {
      section.querySelectorAll('[data-cc-tier-qty]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(parseInt(button.dataset.ccTierQty, 10) === qty));
      });
    }

    async function fillBundle(root, qty, wanted) {
      for (var i = 0; i < wanted.length && selectedProducts(root).length < qty; i++) {
        var card = root.querySelector(CARD + '[id$="-' + wanted[i] + '"]');
        if (!card || card.classList.contains(CARD_ADDED)) continue;
        var button = card.querySelector(CARD_BUTTON);
        if (!button || button.disabled) continue;
        programmatic = true;
        button.click();
        programmatic = false;
        await wait(200);
      }
    }

    function wantedProducts(section, keep) {
      var list = [];
      keep.concat((section.dataset.prefill || '').split(',')).forEach(function (id) {
        if (id && list.indexOf(id) === -1) list.push(id);
      });
      return list;
    }

    async function selectTier(section, qty) {
      var root = builderRoot();
      var quantities = boxQuantities();
      if (!root || !quantities) return;
      var keep = selectedProducts(root);
      if (selectedQty(root) !== qty) {
        var box = boxElements(root)[quantities.indexOf(qty)];
        if (!box) return;
        programmatic = true;
        box.click();
        programmatic = false;
        await wait(400);
      }
      await fillBundle(root, qty, wantedProducts(section, keep));
      markTiers(section, selectedQty(root));
    }

    function placeTrustBadges() {
      var root = builderRoot();
      if (!root) return;
      var cartButton = root.querySelector('.mw-build-offer-add-to-cart');
      if (!cartButton || !cartButton.parentElement) return;
      var buttonGroup = cartButton.parentElement;
      var placed = root.querySelector('.ultimate-badges');
      var fresh = document.querySelector('trust-badges .ultimate-badges');
      if (fresh) {
        if (placed) placed.remove();
        placed = fresh;
      }
      if (!placed) return;
      if (placed.parentElement === buttonGroup.parentElement && placed.previousElementSibling === buttonGroup) return;
      placed.style.marginTop = '12px';
      buttonGroup.insertAdjacentElement('afterend', placed);
    }

    function initTrustBadges() {
      var pending = false;
      function schedule() {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          placeTrustBadges();
        }, 30);
      }
      var observer = new MutationObserver(schedule);
      document.querySelectorAll('trust-badges').forEach(function (element) {
        observer.observe(element, { childList: true, subtree: true });
      });
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var root = builderRoot();
        if (root && !root.ccTrustObserved) {
          root.ccTrustObserved = true;
          observer.observe(root, { childList: true, subtree: true });
        }
        schedule();
        if (tries > 40) clearInterval(timer);
      }, 500);
    }

    function whenBuilderReady(callback) {
      var tries = 0;
      var timer = setInterval(function () {
        var root = builderRoot();
        tries++;
        if (root && boxQuantities() && boxElements(root).length) {
          clearInterval(timer);
          callback(root);
        } else if (tries > 60) {
          clearInterval(timer);
        }
      }, 250);
    }

    function initTiers(section) {
      if (section.dataset.ccTiersReady) return;
      section.dataset.ccTiersReady = 'true';
      var sync = section.dataset.sync === 'true';
      var userActed = false;
      var defaultQty = parseInt(section.dataset.defaultQty, 10) || 0;
      if (defaultQty) markTiers(section, defaultQty);
      if (section.dataset.moveTrust === 'true') initTrustBadges();

      section.addEventListener('click', function (event) {
        var button = event.target.closest('[data-cc-tier-qty]');
        if (!button) return;
        userActed = true;
        var qty = parseInt(button.dataset.ccTierQty, 10);
        markTiers(section, qty);
        if (sync) selectTier(section, qty);
        var target = document.getElementById(section.dataset.step2);
        if (target) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });

      if (!sync) return;

      document.addEventListener(
        'click',
        function (event) {
          if (programmatic || !event.composedPath) return;
          var root = builderRoot();
          var quantities = boxQuantities();
          if (!root || !quantities) return;
          var path = event.composedPath();
          for (var i = 0; i < path.length; i++) {
            var element = path[i];
            if (element.classList && element.classList.contains('CartContent-BoxSelector--box')) {
              var index = boxElements(root).indexOf(element);
              var qty = quantities[index];
              if (!qty || element.classList.contains(BOX_SELECTED)) return;
              userActed = true;
              var keep = selectedProducts(root);
              setTimeout(function () {
                fillBundle(root, qty, wantedProducts(section, keep)).then(function () {
                  markTiers(section, selectedQty(root));
                });
              }, 400);
              return;
            }
          }
        },
        true
      );

      whenBuilderReady(function (root) {
        if (!userActed && defaultQty && boxQuantities().indexOf(defaultQty) !== -1) {
          selectTier(section, defaultQty);
        } else {
          markTiers(section, selectedQty(root));
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-cc-tiers]').forEach(initTiers);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickyBar(bar) {
      if (bar.dataset.ccReady) return;
      bar.dataset.ccReady = 'true';
      var target = document.getElementById(bar.dataset.target);
      var zones = [];
      if (target) {
        var section = target.closest('.shopify-section');
        if (section) {
          zones.push(section);
          if (section.nextElementSibling) zones.push(section.nextElementSibling);
        }
      }
      function update() {
        var viewport = window.innerHeight;
        var show = window.scrollY > viewport * 0.6;
        for (var i = 0; show && i < zones.length; i++) {
          var rect = zones[i].getBoundingClientRect();
          if (rect.top < viewport && rect.bottom > 0) show = false;
        }
        if (show && viewport + window.scrollY >= document.documentElement.scrollHeight - 500) show = false;
        if (show && bar.dataset.yieldTo) {
          var other = null;
          try {
            other = document.querySelector(bar.dataset.yieldTo);
          } catch (error) {
            other = null;
          }
          if (other) {
            var otherRect = other.getBoundingClientRect();
            if (otherRect.height > 0 && otherRect.top < viewport && getComputedStyle(other).visibility !== 'hidden') show = false;
          }
        }
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      bar.hidden = false;
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() {
      document.querySelectorAll('[data-cc-sticky]').forEach(initStickyBar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
